import {AfterViewInit, Component, EventEmitter, OnInit, Output, ViewChildren} from '@angular/core';
import {Layer} from 'storyboard-renderer';

@Component({
  selector: 'app-create-video-layer',
  templateUrl: './create-video-layer.component.html',
  styleUrls: ['./create-video-layer.component.scss']
})
export class CreateVideoLayerComponent implements OnInit, AfterViewInit {

  newLayer: Layer = new Layer(null, '', []);
  @Output() declineEvent = new EventEmitter();
  @Output() acceptEvent = new EventEmitter();

  @ViewChildren('input') vc;

  constructor() { }

  ngOnInit() {
  }

  ngAfterViewInit() {
    this.vc.first.nativeElement.focus();
  }

  accept() {
    if (!this.newLayer.title)
      return;

    this.acceptEvent.next(this.newLayer);
  }

  decline() {
    this.declineEvent.next();
  }

}



// WEBPACK FOOTER //
// ./src/app/storyboard/storyboard-edit/timeline/create-video-layer/create-video-layer.component.ts